import { Collapse, Row, Col, Button } from 'antd';
import { PlusCircleOutlined, UpOutlined } from '@ant-design/icons';
import React, { useContext, useEffect, useState } from 'react';

import styled from 'styled-components';
import LineItemAccordion from './Accordion';
import WorkOrderDetailsContext from '../../../containers/WorkOrder/WorkOrderDetailsContext';

const { Panel } = Collapse;

const StyledPanel = styled(Panel)`
  .ant-collapse-header {
    background: white !important;
  }
  .ant-collapse-content {
    background: white !important;
  }
`;

const StyledCol = styled(Col)`
  display: flex;
  justify-content: center;
  margin-top: 10px;
`;

function LineItems() {
  const contextValue = useContext(WorkOrderDetailsContext);
  const [newLineItems, setNewLineItems] = useState([]);

  const {
    state: { lineItems, inspectionFormId, inspectionFormTitle },
    addSubItem,
    deleteSubItem,
    changeSubItem,
    addNewLineItem,
    deleteLineItem,
    updateVMRSCode,
    moveItem,
    toggleActive,
    changeItemProperty,
    removeInspectionIssue,
  } = contextValue;

  return (
    <Collapse
      defaultActiveKey={['1']}
      style={{ marginBottom: '10px' }}
      expandIconPosition="right"
      expandIcon={({ isActive }) => (
        <div data-testid="line-items-collapse-expand-icon">
          <UpOutlined
            rotate={isActive ? 0 : 180}
            style={{ color: '#123FBF' }}
          />
        </div>
      )}
    >
      <StyledPanel
        key="1"
        header={
          <span style={{ color: '#123FBF' }}>
            Line Items ({lineItems.length})
          </span>
        }
      >
        {lineItems.map((item) => (
          <>
            <LineItemAccordion
              key={item.key}
              item={item}
              moveItem={moveItem}
              deleteLineItem={deleteLineItem}
              updateVMRSCode={updateVMRSCode}
              toggle={toggleActive}
              addSubItem={addSubItem}
              deleteSubItem={deleteSubItem}
              changeSubItem={changeSubItem}
              changeItemProperty={changeItemProperty}
              removeInspectionIssue={removeInspectionIssue}
              inspectionFormId={inspectionFormId}
              inspectionFormTitle={inspectionFormTitle}
            />
          </>
        ))}

        <Row justify="center">
          <StyledCol span={24}>
            <Button
              type="primary"
              ghost
              onClick={() => addNewLineItem()}
              icon={<PlusCircleOutlined />}
            >
              Add New Service Task
            </Button>
          </StyledCol>
        </Row>
      </StyledPanel>
    </Collapse>
  );
}

export default LineItems;
